import React, { FC } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { BeatLoader } from "react-spinners";
import { Alert } from "reactstrap";

import { OverlayLoading } from "components/common/OverlayLoading/OverlayLoading";
import { ProductTypeEnum } from "core/enum/product-type.enum";
import { TGetAllStoreProductsData } from "core/models/store-products.model";
import { useGetAllStoreProducts } from "core/services/api/product.api";
import { ProductsGrid } from "./ProductsGrid";

const PAGE_SIZE = 12;

type Props = {
  productType: ProductTypeEnum;
};

const StoreList: FC<Props> = ({ productType }) => {
  const { data, fetchNextPage, hasNextPage, isLoading } =
    useGetAllStoreProducts({
      pageSize: PAGE_SIZE,
      productType,
    });

  const products: TGetAllStoreProductsData[] =
    data?.pages.flatMap((page) => page.data?.result?.items) || [];

  if (isLoading) return <OverlayLoading />;

  return !products.length ? (
    <Alert className="text-center mt-4" color="warning">
      محصولی یافت نشد
    </Alert>
  ) : (
    <InfiniteScroll
      dataLength={products.length}
      next={fetchNextPage}
      hasMore={!!hasNextPage}
      loader={
        <div className="my-1 text-center">
          <BeatLoader size={7} color="var(--primary)" />
        </div>
      }
      endMessage={<p style={{ textAlign: "center", marginTop: 20 }} />}
    >
      <ProductsGrid data={products} />
    </InfiniteScroll>
  );
};

export { StoreList };